module.exports = __webpack_public_path__ + "img/file-text-icon.c9f58aeb.svg";